import store from '@/services/store';
import translations_FRENCH from '../resources/translations/FR';
import translations_ENGLISH from '../resources/translations/GB';
import translations_GREEK from '../resources/translations/GR';
import translations_DUTCH from '../resources/translations/NL';
import { getTranslatedLanguageWithUserSettings } from './GNRL';

//TOASK: What if i defined translations here as a const. Wouldnt that be an immutable reference to the translations slice
//and therefore always updated or does getState return a clone?

export function translateStatic(value) {
  let lang = getTranslatedLanguageWithUserSettings();

  let retValue;
  if (lang === 'en') {
    retValue = translations_ENGLISH[value];
  } else if (lang === 'nl') {
    retValue = translations_DUTCH[value];
  } else if (lang === 'fr') {
    retValue = translations_FRENCH[value];
  } else if (lang === 'gr' || lang === 'el') {
    retValue = translations_GREEK[value];
  } else {
    retValue = translations_ENGLISH[value];
  }

  //default to english
  if (!retValue) {
    return translations_ENGLISH[value];
  }
  return retValue;
}

const TRANSLATION_PLACEHOLDER_REGEX = /\{([^{}]+)\}/g;

const hasOwn = (object, key) =>
  Object.prototype.hasOwnProperty.call(object, key);

const canUseReplacementValue = (value) => {
  const valueType = typeof value;

  return (
    value !== null &&
    value !== undefined &&
    ['string', 'number', 'boolean'].includes(valueType)
  );
};

const getTranslationReplacement = (replacements, key, placeholder) => {
  const replacementSources = [replacements, replacements?.args].filter(
    (source) => source && typeof source === 'object'
  );
  const possibleKeys = [key, placeholder];

  for (const source of replacementSources) {
    for (const possibleKey of possibleKeys) {
      if (!hasOwn(source, possibleKey)) continue;

      const replacement = source[possibleKey];
      if (canUseReplacementValue(replacement)) {
        return String(replacement);
      }
    }
  }

  return placeholder;
};

export function interpolateTranslation(value, replacements = {}) {
  if (
    typeof value !== 'string' ||
    !replacements ||
    typeof replacements !== 'object'
  ) {
    return value;
  }

  return value.replace(TRANSLATION_PLACEHOLDER_REGEX, (match, key) =>
    getTranslationReplacement(replacements, key, match)
  );
}

// String.prototype.translate = translateStatic; THIS ISNT FP BECASE, GET THIS: YOU'RE MUTATING THE ENV OBJECT!! nice way to think about it. also practically it might mess up because globals but you know..
export function translate(value, replacements, category) {
  var translated = category ? undefined : translateStatic(value);
  if (!translated) {
    return interpolateTranslation(
      translateLookupEverything(value, category),
      replacements
    );
  }
  return interpolateTranslation(
    translated
      .replace('%%app%%', getAppTranslation())
      .replace('%%app%%', getAppTranslation()),
    replacements
  );
}
const getAppTranslation = () => 'novoville';

function translateLookupEverything(value, category) {
  const translations = store.getState().translationsReducer?.translations;

  if (!translations) {
    return value;
  }

  if (category) {
    return translations[category]?.[value] ?? value;
  }

  for (var key in translations) {
    if (translations[key]?.[value]) {
      return translations[key][value];
    }
  }
  return value;
}

export function translateCountry(value) {
  const translations = store.getState().translationsReducer.translations;
  return translations.countries[value];
}

export function translateAuthority(value) {
  const translations = store.getState().translationsReducer.translations;
  return translations.authorities[value];
}

export function translateAPICode(value, replacements) {
  const translations = store.getState().translationsReducer.translations;
  if (translations) {
    return interpolateTranslation(translations.responses[value], replacements);
  }
  return interpolateTranslation(value, replacements);
}

export function translateIssue(value) {}

export function translatePOIType(value) {
  const translations = store.getState().translationsReducer.translations;
  return translations.pois[value];
}
